module.exports = __webpack_public_path__ + "static/media/ic-playdapp-logo.7fd91b20.svg";